/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingAccountInput
 */
export interface BillingAccountInput {
    /**
     * 
     * @type {string}
     * @memberof BillingAccountInput
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountInput
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountInput
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountInput
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountInput
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountInput
     */
    companyRegistrationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountInput
     */
    vatNumber?: string | null;
}

/**
 * Check if a given object implements the BillingAccountInput interface.
 */
export function instanceOfBillingAccountInput(value: object): value is BillingAccountInput {
    return true;
}

export function BillingAccountInputFromJSON(json: any): BillingAccountInput {
    return BillingAccountInputFromJSONTyped(json, false);
}

export function BillingAccountInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingAccountInput {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'street': json['street'] == null ? undefined : json['street'],
        'city': json['city'] == null ? undefined : json['city'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'email': json['email'] == null ? undefined : json['email'],
        'companyRegistrationNumber': json['companyRegistrationNumber'] == null ? undefined : json['companyRegistrationNumber'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
    };
}

export function BillingAccountInputToJSON(json: any): BillingAccountInput {
    return BillingAccountInputToJSONTyped(json, false);
}

export function BillingAccountInputToJSONTyped(value?: BillingAccountInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'street': value['street'],
        'city': value['city'],
        'zip': value['zip'],
        'email': value['email'],
        'companyRegistrationNumber': value['companyRegistrationNumber'],
        'vatNumber': value['vatNumber'],
    };
}

